import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

import CreatePostButton from '../action-buttons/create-post-button';
import FaqActionButton from '../action-buttons/tips-faq-button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      color: theme.palette.primary.main,
      textAlign: 'center',
    },
    textBlock: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(3),
      fontSize: '1.6em',
    },
    stepInstructions: {
      fontSize: '1.6em',
    },
    stepCounter: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(2),
      borderRadius: '40px',
      width: '30px',
      height: '30px',
      paddingTop: '2px',
      display: 'inline-block',
      fontWeight: 'bold',
    },
    quoteBlock: {
      textAlign: 'center',
      fontWeight: 'bold',
      color: theme.palette.primary.main,
      paddingTop: theme.spacing(8),
    },
    iconSpacer: {
      position: 'relative',
      top: '5px',
    },
    linkUnderline: {
      textDecoration: 'underline',
      hover: 'pointer',
    },
  }),
);

export default function PostListEmpty(props: any) {
  const classes = useStyles(baseTheme);

  return (
    <Grid item container direction="column" className={classes.root}>
      <Grid item container direction="column">

        <Typography className={classes.textBlock}>
          You haven't created any posts yet.
          Click <CreatePostButton text={'here'}
            className={classes.linkUnderline} /> to
          get started with your first post.
        </Typography>

        <Grid item className={classes.stepInstructions}>
          <span className={classes.stepCounter}>1</span><span>Post</span>
          <span className={classes.stepCounter}>2</span><span>Highlight</span>
          <span className={classes.stepCounter}>3</span><span>Reflect</span>
        </Grid>

        <Typography>
          To view tips to help you get started, simply click on &nbsp;
          <FaqActionButton iconOnly={true} className={classes.iconSpacer} />.
        </Typography>
      </Grid>

      <Grid item className={classes.quoteBlock}>
        Record the vision and inscribe it on tablets, that the one who reads it may run.
        Habakkuk 2:2
      </Grid>
    </Grid>
  );
}
